<template>
  <div class="item_content">
    <div
      class="item_title"
      style="display: flex; justify-content: space-between"
    >
      <div>
        {{ ProductItem.Name }}
      </div>
      <div style="width: 70px; color: red; font-size: 13pt; height: 30px">
        {{ ProductItem.PriceFormat }}
      </div>
    </div>

    <div class="item_content_area" @click="LookProductDetail(ProductItem)">
      <van-image  :style="{ height: imageHeigth + 'px' }"
        class="item_picture"
        fit="contain"
        :src="ProductItem.CompleteImages"
      >
        <template v-slot:error> </template>
      </van-image>

      <div class="item_price_cart">
        <p class="description" v-html="ProductItem.Description"></p>
      </div>
    </div>
    <div class="item_bottom" style="height: 50px; align-items: center;">
      <div>
        {{ tools.GetLanguageValue("public.app.已点") }}
        {{ ProductItem.PlaceCount }}
      </div>
      <van-button type="primary" style="width: 100px;" size="small" round  @click="LookProductDetail()">
          <van-icon name="shopping-cart"  size="17" /> </van-button
        >
    </div>
  </div>

  <!-- 固定套餐 -->
  <van-action-sheet v-model:show="FixationWindow" :title="Product.Name">

    <div
          style="padding: 5px 5px 20px 5px"
          v-html="ProductItem.Description"
        ></div>

    <div
      class="item_content"
      v-for="(item, index) in FixationProducts"
      :key="index"
    >
      <div
        class="item_title"
        style="display: flex; justify-content: space-between"
      >
        <div>
          {{ item.Name }}
        </div>
        <div style="width: 70px; color: red; font-size: 13pt; height: 30px">
          <!-- {{ item.PriceFormat }} -->
        </div>
      </div>

      <div class="item_content_area">
        <van-image
          class="item_picture"
          fit="contain"
          :src="item.CompleteImages"
        >
          <template v-slot:error> </template>
        </van-image>

        <div class="item_price_cart">
          <p class="description" v-html="item.Description"></p>
        </div>
      </div>
    </div>

    <van-col
      span="24"
      style="
        position: absolute;
        bottom: 5px;
        width: 100%;
        text-align: center;
        z-index: 1000000;
      "
    >
      <van-button
        @click="AddShoppingCart()"
        style="width: calc(100% - 50px)"
        color="rgb(0, 157, 255)"
      >
        {{ tools.GetLanguageValue("public.app.添加") }}
      </van-button>
    </van-col>
  </van-action-sheet>
</template>
<script >
import axios from "../../commons/AxiosMethod.js"
import tools from "../../commons/tools.js"
import AttributeGroupModule from "../AttributeGroupModule.vue"
import { showToast } from "vant"
export default {
  data () {
    return {
      productImg: require("../../assets/正方形logo.png"),
      index: 0,
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      Product: {
        Count: 0
      }, // 商品
      tools: tools,

      ProductAttributeOpt: [], // 选中属性
      ProductRemarkOpts: [], // 选中备注
      TableId: "", // 桌台ID

      FixationProducts: false,
      FixationWindow: false,
      imageHeigth: 100,
    }
  },
  name: "App",
  props: {
    ProductItem: {},
    ImageHeigth:100,
  },
  mounted () {
    this.Product = this.ProductItem
    this.ProductRemarkOpts = []
    this.TableId = localStorage.getItem("Cache-TableId")

    this.imageHeigth = this.ImageHeigth;
    if (this.imageHeigth < 100) {
      this.imageHeigth = 100;
    }
  },
  components: {
    AttributeGroupModule
  },
  methods: {
    beforeChange (value) {
      console.log(value)
    },
    // 查看详细页面
    LookProductDetail () {
      const param = { Id: this.ProductItem.Id }
      axios.apiMethod(
        "/Shopping/Product/GetCollectionFixationProducts",
        "get",
        param,
        (result) => {
          this.FixationWindow = true
          this.FixationProducts = result.Data
        }
      )
    },
    // 添加购物车
    AddShoppingCart () {
      const param = {
        ProductId: this.Product.Id,
        Count: 1,
        Remarks: this.Product.Remarks,
        OptProductRemarkItems: this.ProductRemarkOpts,
        ProductRemarkItemsOpt: this.ProductRemarkOpts,
        ProductAttributeGroups: this.Product.Groups,
        TableId: this.TableId
      }

      axios.apiMethod(
        "/Store/StoreOrder/AddShoppingCart",
        "post",
        param,
        (result) => {
          try {
            if (result.Data.IsSuccess) {
              showToast(result.Data.Msg)
              this.ProductRemarkOpts = []

              this.ProductItem.Count += 1
              this.FixationWindow = false
              tools.GetShoppingCartComplete(this.TableId)
            } else {
              showToast(result.Data.Msg)
              this.ProductItem.Count -= 1
              if (this.ProductItem.Count <= 0) {
                this.ProductItem.Count = 0
              }
            }
          } catch (error) {}
        }
      )
    }, // 减少商品
    MinusCartItem () {
      axios.apiMethod(
        "/Store/StoreOrder/CutShoppingCartByProductId",
        "post",
        {
          ProductId: this.Product.Id,
          TableId: this.TableId
        },
        (result) => {
          if (result.Data.IsSuccess) {
            this.ProductItem.Count = result.Data.Model.Count
            tools.GetShoppingCartComplete(this.TableId)

            return
          }
          showToast(result.Data.Msg)
        },
        (e) => {}
      )
    }
  }
}
</script>

  <style lang="scss" scoped>
.product_remark {
  padding: 5px 22px;
  font-size: 7pt;
}

.item_content {
  max-width: 100%; 
  background-color: #fff;
  padding: 15px;
  border-radius: 15px;
  margin-top: 5px;

  .pricture_name {
    color: #333;
    font-size: 11pt;
    width: calc(100% - 70px);
    height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    font-weight: 500;
    margin-left: 10px;
  }

  .item_content_area {
    margin: 0 auto;
    margin-top: 10px;
    width: calc(100% - 20px); 
    border-radius: 5px;
    display: flex;
    border-bottom: 1px dashed rgb(166, 163, 163);

    .item_picture {
      background-color: #fff;
      width: 125px; 
    }

    .item_price_cart {
      margin: 0 auto;
      font-size: 9pt;
      width: calc(100% - 135px);
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      position: relative;

      .description {
        width: 100%;
        padding: 0px 5px;
        overflow: hidden;
        height: 46px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        font-size: 12px;
        text-overflow: ellipsis;
        white-space: normal;
      }

      .item_price_cart_bottom {
        position: absolute;
        height: 40px;
        bottom: 0px;
        right: 0px;
        line-height: 40px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .item_price {
          width: 60px;
          line-height: 40px;
          color: #333;
          font-family: "Titillium Web", Arial, sans-serif;
          font-size: 13pt;
        }
      }
    }
  }

  .item_content_chengfen {
    height: 20px;
    display: flex;
 

    .items {
      width: 20px;
      height: 20px;
      border: 1px solid #333;
      margin-left: 5px;
      text-align: center;
    }
  }
}

.stepper_content {
  display: flex;
  width: 100px;
  text-align: right;
  height: 40px;
  line-height: 40px;
}

.item_bottom {
  width: 100%;
  display: flex;
  justify-content: space-between;

}
</style>
